import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlatButton } from 'material-ui';

export class ImageButtonPicker extends Component {
  static propTypes = {
    label: PropTypes.any,
    onFile: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    accept: PropTypes.string,
  };

  onInputChange(e) {
    Array.from(e.target.files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (r) => {
        // Pass both File (for signed URL upload) and data URL (for preview)
        this.props.onFile(file, r.target.result);
      };
      reader.readAsDataURL(file);
    });
    e.target.value = '';
  }

  componentDidMount() {
    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this), false);
    }
  }

  componentWillUnmount() {
    if (this.input) {
      this.input.removeEventListener('change', this.onInputChange.bind(this), false);
    }
  }

  render() {
    return (
      <FlatButton
        fullWidth={this.props.fullWidth}
        disabled={this.props.disabled}
        style={{ marginTop: 10, marginBottom: 10 }}
        containerElement="label"
        label={this.props.label}
      >
        <input
          accept={this.props.accept || 'image/x-png,image/gif,image/jpeg,image/webp'}
          type="file"
          ref={(ref) => (this.input = ref)}
        />
      </FlatButton>
    );
  }
}
